import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { DataTablePagination } from '@/types/_'
import { Contrato } from '@/types/core'
import MedicoRecebimentoTipoEnum from '@/types/enum/TipoProducaoEnum'

type Mode = 'CREATE' | 'EDIT'

type SetRegrasDeCalculoModal = {
  name: string,
  value: boolean,
}

type RegrasDeCalculoModal = {
  regraDeCalculo: boolean,
  valoresFixosIncluir: boolean,
  garantiaMinimaIncluir: boolean,
  regraDeCalculoContrato: boolean,
  regraDeCalculoOperadora: boolean,
  regraDeCalculoProcedimentosDescartar: boolean,
  procedimentos: boolean,
  procedimentoCompartilhado: boolean,
  plano: boolean,
  filtroProcedimento: boolean,
  regraGarantiaMinimaAddHospital: boolean,
  regraDeCalculoGarantiaMinima: boolean,
  regraDeCalculoGestao: boolean,
}

type KeyDisplay = {
  key: string,
  display: string,
}

interface TabelaPreco {
  id: number,
  identificador: number,
  nome: string,
}

interface Regra {
  id: string,
  descricaoRegra: string | null,
  fatorRegra: number | null,
  valorDeReferencia: KeyDisplay | null,
  valorDeReferenciaTipo: KeyDisplay | string | null,
  valorDeReferenciaFixo: number | null,
  tabelaPrecoPropria: boolean | null,
  tabelaPrecoId: string | null,
  aplicarFatorAcomodacao: boolean | null,
  aplicarFatorFuncaoTabela: boolean | null,
  aplicarPontuacaoProfissional: boolean | null,
  aplicarFatorViaTabela: boolean | null,
  gerarItemInstrumentador: boolean | null,
  filtraPorOperadora: boolean | null,
  filtraPorCodigoProcedimento: boolean | null,
  ativo: boolean | null,
  considerarTabelaPrecoPontuacao: boolean | null,
  considerarTabelaPediatria: boolean | null,
  descartaPacote: boolean | null,
  descartaPertencePacote: boolean | null,
  createdBy: string | null,
  createdOn: string | null,
  createdByNome: string | null,
  considerarValorPacote: boolean | null,
}

interface Procedimentos {
  valorGarantiaMinima: number,
  codigoProcedimento: string,
  descricaoProcedimento: string,
}

interface RegraDeCalculo {
  aplicarFatorAcomodacao: boolean | null,
  categoriaDedicacao: number,
  cnpjFontePagadora: string | null,
  cnpjPrestador: string | null,
  codigoHisRegra: string | null,
  createdByNome: string | null
  createdOn: string | null,
  descricaoRegra: string | null,
  fatorRegra: number,
  fontePagadoraId: string | null,
  id: string,
  nomeFontePagadora: string | null,
  nomeGrupoHospital: string | null,
  nomeOperadora: string | null,
  nomePrestador: string | null,
  nomeTabelaIndice: string | null,
  nomeTabelaPreco: string | null,
  operadoraId: string | null,
  percentualTaxaAdministrativa: number,
  pontuacaoDedicacao: number,
  prestadorId: string | null,
  removedOn: string | null,
  tabelaIndiceAtual: string | null,
  tabelaIndiceId: string | null,
  tabelaPrecoId: string,
  tabelaPrecoPropria: boolean,
  usarGrupoProcedimentoGeral: boolean | null,
  considerarTabelaPediatria: boolean | null,
  considerarTabelaPrecoProfissional: boolean | null,
  considerarTabelaPrecoPrestador: boolean | null,
  valorDeReferenciaFixo: number,
  valorDeReferencia: {
    key: string,
    display: string,
  },
}

interface RegraDeCalculoContrato {
  id: string,
  contratoId: string,
  fontePagadoraNome: string,
  prestadorNome: string,
  regraCalculoId: string | null
  createdByNome: string | null,
  createdOn: string | null,
  removedBy: string | null,
  removedOn: string | null,
}

interface RegraDeCalculoOperadora {
  id: string,
  regraCalculoId: string | null,
  nomeOperadoraHis: string | null,
  codigoHis: string | null,
  createdByNome: string | null,
  createdOn: string | null,
}

export interface PessoaOperadora {
  classificacaoCodigoHis: string | null,
  classificacaoNome: string | null,
  codigoHis: string | null,
  nome: string | null,
  userId: string | null,
}

export interface ClassificacaoOperadora {
  id: number | null,
  classificacaoCodigoHis: string | null,
  classificacaoNome: string | null,
}

interface Prestador {
  documento: string,
  nome: string,
  prestadorId: string,
}

interface Contrato {
  contratoId: string,
  nomeFontePagadora: string | null,
  nomePrestador: string,
  cnpjPrestador: number,
  razaoSocialPrestador: string | null,
}

interface ProcedimentoDescartar {
  id?: string,
  regraCalculoId?: string,
  codigoProcedimento: string,
  descricaoProcedimento: string,
  createdByNome?: string | null,
  createdOn?: string | null,
  removedOn?: string | null,
  removedBy?: string | null,
}

@Module({ namespaced: true, name: 'RegrasDeCalculoStore' })
export default class RegrasDeCalculoStore extends VuexModule {
  public mode: Mode = 'CREATE'
  public modeModalRegraValoresFixos: Mode = 'CREATE'
  public modeModalRegraGestao: Mode = 'CREATE'
  public modeModalGarantiaMinima: Mode = 'CREATE'

  public modal: RegrasDeCalculoModal = {
    regraDeCalculo: false,
    valoresFixosIncluir: false,
    regraDeCalculoContrato: false,
    regraDeCalculoOperadora: false,
    regraDeCalculoProcedimentosDescartar: false,
    garantiaMinimaIncluir: false,
    procedimentos: false,
    procedimentoCompartilhado: false,
    plano: false,
    filtroProcedimento: false,
    regraGarantiaMinimaAddHospital: false,
    regraDeCalculoGarantiaMinima: false,
    regraDeCalculoGestao: false,
  }

  public tiposProducao: { key: MedicoRecebimentoTipoEnum | null; display: string }[] = [
    { key: null, display: 'Todos' },
    { key: MedicoRecebimentoTipoEnum.Material, display: 'Material' },
    { key: MedicoRecebimentoTipoEnum.Procedimento, display: 'Procedimento' },
    { key: MedicoRecebimentoTipoEnum.Exame, display: 'Exame' },
    { key: MedicoRecebimentoTipoEnum.Revisao, display: 'Revisão' },
  ];

  public modalProcedimentoCompartilhadoMode: string = 'CREATE'

  @Mutation
  setModal(modal: SetRegrasDeCalculoModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setMode(mode: Mode) {
    this.mode = mode
  }

  @Mutation
  setModeModalRegraValoresFixos(mode: Mode) {
    this.modeModalRegraValoresFixos = mode
  }

  @Mutation
  setModeModalRegraGestao(mode: Mode) {
    this.modeModalRegraGestao = mode
  }

  @Mutation
  setModeModalGarantiaMinima(mode: Mode) {
    this.modeModalGarantiaMinima = mode
  }

  /** Valores de referência */
  private valoresDeReferenciaDefault: KeyDisplay[] = []
  public valoresDeReferencia: KeyDisplay[] = [...this.valoresDeReferenciaDefault]

  @Mutation
  setValoresDeReferencia(valoresDeReferencia: KeyDisplay[]) {
    this.valoresDeReferencia = valoresDeReferencia
  }

  @Mutation
  clearValoresDeReferencia() {
    this.valoresDeReferencia = [...this.valoresDeReferenciaDefault]
  }

  @Action
  async getValorDeReferenciaEnum() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValorDeReferenciaEnum()
      if (request.success) this.context.commit('setValoresDeReferencia', request.data as KeyDisplay[] || [])
      return request
    } catch (error) {
      this.context.commit('clearValoresDeReferencia')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Regras de calculo */
  private paginacaoRegrasDeCalculoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 25,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  public paginacaoRegrasDeCalculo: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoCadastroHospitaisGarantiaMinimaGlobal: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoFiltroPorProcedimento: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoRegrasValorFixo: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoGarantiaMinima: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public paginacaoRegraGestao: DataTablePagination = { ...this.paginacaoRegrasDeCalculoDefault }
  public activeTab: number = 0

  get regrasDeCalculoPaginationDefault() {
    return this.paginacaoRegrasDeCalculoDefault
  }

  @Mutation
  setPaginacaoRegrasDeCalculo(val: DataTablePagination) {
    this.paginacaoRegrasDeCalculo = val
  }

  @Mutation
  setPaginacaoCadastroHospitaisGarantiaMinimaGlobal(val: DataTablePagination) {
    this.paginacaoCadastroHospitaisGarantiaMinimaGlobal = val
  }

  @Mutation
  setPaginacaoFiltroPorProcedimento(val: DataTablePagination) {
    this.paginacaoFiltroPorProcedimento = val
  }

  @Mutation
  setActiveTab(tab: number) {
    this.activeTab = tab
  }

  @Mutation
  setPaginacaoRegrasValorFixo(val: DataTablePagination) {
    this.paginacaoRegrasValorFixo = val
  }

  @Mutation
  setPaginacaoGarantiaMinima(val: DataTablePagination) {
    this.paginacaoGarantiaMinima = val
  }

  @Mutation
  setPaginacaoRegraGestao(val: DataTablePagination) {
    this.paginacaoRegraGestao = val
  }

  public regrasDeCalculo: any = []
  public regrasValorFixo: any = []
  public regrasGarantiaMinima: any = []
  public regraGestao: any = []
  public regraValorFixoItem: any = {}
  public regraGestaoItem: any = {}
  public regraGarantiaMinimaId: any = ''
  public regraGestorId: any = ''
  public regraValorFixoId: any = ''
  public regraGarantiaMinimaItem: any = {}

  @Mutation
  setRegrasDeCalculo(regrasDeCalculo: RegraDeCalculo[]) {
    this.regrasDeCalculo = regrasDeCalculo
  }

  @Mutation
  setRegrasValorFixo(regrasValorFixo: any[]) {
    this.regrasValorFixo = regrasValorFixo
  }

  @Mutation
  setRegrasGarantiaMinima(regrasGarantiaMinima: any[]) {
    this.regrasGarantiaMinima = regrasGarantiaMinima
  }

  @Mutation
  setRegraGestao(regras: any[]) {
    this.regraGestao = regras
  }

  @Mutation
  setRegraValorFixoItem(item: any) {
    this.regraValorFixoItem = item
  }

  @Mutation
  setRegraGarantiaMinimaItem(item: any) {
    this.regraGarantiaMinimaItem = item
  }

  @Mutation
  setRegraGestaoItem(item: any) {
    this.regraGestaoItem = item
  }

  @Mutation
  clearRegrasDeCalculo() {
    this.regrasDeCalculo = []
  }

  @Mutation
  setRegraDeCalculoIdGarantiaMinima(value: any) {
    this.regraGarantiaMinimaId = value
  }

  @Mutation
  setIdRegraGestor(value: any) {
    this.regraGestorId = value
  }

  @Mutation
  clearRegraGestao() {
    this.regraGestaoItem = {}
  }

  @Mutation
  setRegraValorFixoId(value: any) {
    this.regraValorFixoId = value
  }

  @Action
  async getRegraCalculoAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegrasDeCalculo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasDeCalculo.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoAll(params)
      if (request.success) {
        this.context.commit('setRegrasDeCalculo', request.data.regras as RegraDeCalculo[])
        this.context.commit('setPaginacaoRegrasDeCalculo', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasDeCalculo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasDeCalculo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasDeCalculo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegrasDeCalculo')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegrasValorFixo(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegrasValorFixo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasValorFixo(params)
      if (request.success) {
        this.context.commit('setRegrasValorFixo', request.data.itens)
        this.context.commit('setPaginacaoRegrasValorFixo', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasValorFixo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasValorFixo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegrasDeCalculo')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegrasGarantiaMinima(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegrasValorFixo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasGarantiaMinima(params)
      if (request.success) {
        this.context.commit('setRegrasGarantiaMinima', request.data.itens)
        this.context.commit('setPaginacaoGarantiaMinima', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasValorFixo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasValorFixo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegrasGestao(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoRegrasValorFixo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
        fontePagadoraId: this.regraGestaoItem.fontePagadoraId,
        localExecucaoId: this.regraGestaoItem.localExecucaoId,
        nomeGestor: this.regraGestaoItem.gestorId,
        tipoCalculo: this.regraGestaoItem.tipoCalculo,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasGestao(params)
      if (request.success) {
        this.context.commit('setRegraGestao', request.data.itens)
        this.context.commit('setPaginacaoRegraGestao', {
          descending: false,
          page: pagination.page || this.paginacaoRegrasValorFixo.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoRegrasValorFixo.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoRegrasValorFixo.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Tabela preco */
  private tabelasPrecoDefault: TabelaPreco[] = []
  public tabelasPreco: TabelaPreco[] = [...this.tabelasPrecoDefault]

  @Mutation
  setTabelasPreco(tabelasPreco: TabelaPreco[]) {
    this.tabelasPreco = tabelasPreco
  }

  @Mutation
  clearTabelasPreco() {
    this.tabelasPreco = [...this.tabelasPrecoDefault]
  }

  @Action
  async getTabelaPrecoAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaPrecoAll()
      if (request.success) this.context.commit('setTabelasPreco', request.data as TabelaPreco[] || [])
      return request
    } catch (error) {
      this.context.commit('clearTabelasPreco')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Regra de calculo */
  private regraDeCalculoDefault: Regra = {
    id: '',
    descricaoRegra: '',
    fatorRegra: null,
    valorDeReferencia: null,
    valorDeReferenciaTipo: null,
    valorDeReferenciaFixo: null,
    tabelaPrecoPropria: null,
    tabelaPrecoId: null,
    aplicarFatorAcomodacao: null,
    aplicarFatorFuncaoTabela: null,
    aplicarPontuacaoProfissional: null,
    aplicarFatorViaTabela: null,
    gerarItemInstrumentador: null,
    filtraPorOperadora: null,
    filtraPorCodigoProcedimento: null,
    ativo: null,
    considerarTabelaPrecoPontuacao: null,
    considerarTabelaPediatria: null,
    descartaPacote: null,
    descartaPertencePacote: null,
    createdBy: null,
    createdOn: null,
    createdByNome: null,
    considerarValorPacote: null,
  }

  public regraDeCalculo: Regra = { ...this.regraDeCalculoDefault }

  @Mutation
  setRegraDeCalculo(regraDeCalculo: Regra) {
    if (regraDeCalculo.valorDeReferenciaTipo) {
      this.regraDeCalculo = { ...regraDeCalculo, valorDeReferenciaTipo: (regraDeCalculo.valorDeReferenciaTipo as KeyDisplay).key || null }
    } else {
      this.regraDeCalculo = regraDeCalculo
    }
  }

  @Mutation
  setRegraDeCalculoField(keypair: { field: string, value: any}) {
    this.regraDeCalculo[keypair.field] = keypair.value
  }

  @Mutation
  clearRegraDeCalculo() {
    this.regraDeCalculo = { ...this.regraDeCalculoDefault }
  }

  @Mutation
  clearRegraValorFixoItem() {
    this.regraValorFixoItem = {}
  }

  @Mutation
  clearRegraGarantiaMinimaItem() {
    this.regraGarantiaMinimaItem = {}
  }

  @Action
  async getRegraCalculoById(regraCalculoId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoById(regraCalculoId)
      if (request.success) this.context.commit('setRegraDeCalculo', request.data as Regra)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraCalculoValorFixo() {
    try {
      const regraCalculoId = this.regraValorFixoId
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraCalculoValorFixo(regraCalculoId)
      if (request.success) {
        this.context.dispatch('getRegrasValorFixo', this.paginacaoRegrasValorFixo)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraGarantiaMinima() {
    try {
      const param: any = {
        id: this.regraGarantiaMinimaId,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraGarantiaMinima(param)
      if (request.success) {
        this.context.dispatch('getRegrasGarantiaMinima', this.paginacaoGarantiaMinima)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraGestao() {
    try {
      const idCalculoGestor = this.regraGestorId

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraGestao(idCalculoGestor)
      if (request.success) {
        this.context.dispatch('getRegrasGestao', this.paginacaoRegrasValorFixo)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertRegraCalculo() {
    try {
      const params: any = { ...this.regraDeCalculo }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.upsertRegraCalculo(params)
      if (request.success && !!request.data) {
        this.context.dispatch('getRegraCalculoById', request.data as string)
        this.context.commit('setMode', 'EDIT')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Contratos */
  public regraDeCalculoContratos: RegraDeCalculoContrato[] = []
  private regraDeCalculoContratoDefault: RegraDeCalculoContrato = {
    id: '',
    contratoId: '',
    fontePagadoraNome: '',
    prestadorNome: '',
    regraCalculoId: '',
    createdByNome: null,
    createdOn: null,
    removedBy: null,
    removedOn: null,
  }

  public regraDeCalculoContrato: RegraDeCalculoContrato = { ...this.regraDeCalculoContratoDefault }
  public prestadoresSearchList: Prestador[] = []
  public prestadorIdSearch: string = ''

  @Mutation
  setRegraDeCalculoContrato(regraDeCalculoContrato: RegraDeCalculoContrato) {
    this.regraDeCalculoContrato = regraDeCalculoContrato
  }

  @Mutation
  clearRegraDeCalculoContrato() {
    this.regraDeCalculoContrato = { ...this.regraDeCalculoContratoDefault }
  }

  @Mutation
  setRegraDeCalculoContratos(regraDeCalculoContratos: RegraDeCalculoContrato[]) {
    this.regraDeCalculoContratos = regraDeCalculoContratos
  }

  @Mutation
  clearRegraDeCalculoContratos() {
    this.regraDeCalculoContratos = []
  }

  private paginacaoContratosDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 25,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  public paginacaoContratos: DataTablePagination = { ...this.paginacaoContratosDefault }
  get contratoPaginationDefault() {
    return this.paginacaoContratosDefault
  }

  @Mutation
  setPaginacaoContratos(val: DataTablePagination) {
    this.paginacaoContratos = val
  }

  @Mutation
  setPrestadorIdSearch(value: string) {
    this.prestadorIdSearch = value
  }

  @Mutation
  setPrestadoresSearchList(prestadores: Prestador[]) {
    this.prestadoresSearchList = prestadores
  }

  @Mutation
  clearPrestadoresSearchList() {
    this.prestadoresSearchList = [] as Prestador[]
  }

  @Action
  async getRegraCalculoContratoAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoContratos.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoContratos.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
        prestadorId: this.prestadorIdSearch || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoContratoAll(params)
      if (request.success) {
        this.context.commit('setRegraDeCalculoContratos', request.data.itens as RegraDeCalculoContrato[] || [])
        this.context.commit('setPaginacaoContratos', {
          descending: false,
          page: pagination.page || this.paginacaoContratos.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoContratos.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoContratos.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegraDeCalculoContratos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPrestadoresContratoByRegraCalculoId() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadoresContratoByRegraCalculoId({
        regraCalculoId: this.regraDeCalculo.id,
        prestadorId: '',
      })

      if (request.success) {
        this.context.commit('setPrestadoresSearchList', request.data as Prestador[])
        this.context.commit('setPrestadorIdSearch', '')
      }

      return request
    } catch (error) {
      this.context.commit('clearPrestadoresSearchList')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteRegraCalculoContrato(contratoId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteRegraCalculoContrato({ regraCalculoId: this.regraDeCalculo.id, contratoId })
      if (request.success) {
        await this.context.dispatch('getRegraCalculoContratoAll', {
          pagina: this.paginacaoContratos.page,
          qtdPorPagina: this.paginacaoContratos.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Lista de prestadores */
  public prestadores: Prestador[] = []
  public prestadorId: string = ''

  @Mutation
  setPrestadores(prestadores: Prestador[]) {
    this.prestadores = prestadores
  }

  @Mutation
  clearPrestadores() {
    this.prestadores = []
  }

  @Mutation
  setPrestadorId(value: string) {
    this.prestadorId = value
  }

  @Action
  async getPrestadorContratoCliente(nome: string = '') {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadorContratoCliente(nome)
      if (request.success) this.context.commit('setPrestadores', request.data as Prestador[])
      return request
    } catch (error) {
      this.context.commit('clearPrestadores')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Lista de contratos */
  public contratos: Contrato[] = []

  @Mutation
  setContratos(contratos: Contrato[]) {
    this.contratos = contratos
  }

  @Mutation
  clearContratos() {
    this.contratos = []
  }

  @Action
  async getContratoByPrestador() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getContratoByPrestador(this.prestadorId)
      if (request.success) this.context.commit('setContratos', request.data as Contrato[] || [])
      return request
    } catch (error) {
      this.context.commit('clearContratos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  public contratosId: any[] = []

  @Mutation
  setContratosId(value: any[]) {
    this.contratosId = value
  }

  @Mutation
  clearContratosId() {
    this.contratosId = []
  }

  @Action
  async postRegraCalculoContrato() {
    try {
      const params: any = {
        regraDeCalculoId: this.regraDeCalculo.id,
        contratosId: this.contratosId.map(x => x.contratoId),
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postRegraCalculoContrato(params)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoContratoAll', {
          pagina: this.paginacaoContratos.page,
          qtdPorPagina: this.paginacaoContratos.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Operadoras */
  public regraDeCalculoOperadoras: RegraDeCalculoOperadora[] = []

  @Mutation
  setRegraDeCalculoOperadoras(regraDeCalculoOperadoras: RegraDeCalculoOperadora[]) {
    this.regraDeCalculoOperadoras = regraDeCalculoOperadoras
  }

  @Mutation
  clearRegraDeCalculoOperadoras() {
    this.regraDeCalculoOperadoras = []
  }

  private paginacaoOperadorasDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  public paginacaoOperadoras: DataTablePagination = { ...this.paginacaoOperadorasDefault }
  get operadoraPaginationDefault() {
    return this.paginacaoOperadorasDefault
  }

  @Mutation
  setPaginacaoOperadoras(val: DataTablePagination) {
    this.paginacaoOperadoras = val
  }

  @Action
  async getRegraCalculoOperadoraAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoOperadoraAll(params)
      if (request.success) {
        this.context.commit('setRegraDeCalculoOperadoras', request.data.itens as RegraDeCalculoOperadora[] || [])
        this.context.commit('setPaginacaoOperadoras', {
          descending: false,
          page: pagination.page || this.paginacaoOperadoras.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoOperadoras.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegraDeCalculoOperadoras')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Pessoa Operadora */
  public pessoaOperadoras: PessoaOperadora[] = []

  @Mutation
  setPessoaOperadoras(operadoras: PessoaOperadora[]) {
    this.pessoaOperadoras = operadoras
  }

  @Mutation
  clearPessoaOperadoras() {
    this.pessoaOperadoras = []
  }

  @Action
  async getPessoaOperadoraAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPessoaOperadoraAll()
      if (request.success) this.context.commit('setPessoaOperadoras', request.data.convenios as PessoaOperadora[] || [])
      return request
    } catch (error) {
      this.context.commit('clearPessoaOperadoras')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Classificacao Operadora */
  public classificacaoOperadoras: ClassificacaoOperadora[] = []

  @Mutation
  setClassificacaoOperadoras(classificacaoOperadoras: ClassificacaoOperadora[]) {
    this.classificacaoOperadoras = classificacaoOperadoras
  }

  @Mutation
  clearClassificacaoOperadoras() {
    this.classificacaoOperadoras = []
  }

  @Action
  async getClassificacaoOperadoraAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getClassificacaoOperadoraAll()
      if (request.success) this.context.commit('setClassificacaoOperadoras', request.data as ClassificacaoOperadora[] || [])
      return request
    } catch (error) {
      this.context.commit('clearClassificacaoOperadoras')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  public porOperadoraOuPorClassificacao: 'PorOperadora' | 'PorClassificacao' = 'PorOperadora'

  @Mutation
  setPorOperadoraOuPorClassificacao(value: 'PorOperadora' | 'PorClassificacao') {
    this.porOperadoraOuPorClassificacao = value
  }

  /** Incluir Operadora */
  private pessoaOperadoraAIncluirDefault: PessoaOperadora = {
    userId: null,
    nome: null,
    classificacaoCodigoHis: null,
    classificacaoNome: null,
    codigoHis: null,
  }

  public pessoaOperadoraAIncluir: PessoaOperadora = { ...this.pessoaOperadoraAIncluirDefault }

  @Mutation
  setPessoaOperadoraAIncluir(val: PessoaOperadora) {
    this.pessoaOperadoraAIncluir = val
  }

  @Mutation
  clearPessoaOperadoraAIncluir() {
    this.pessoaOperadoraAIncluir = { ...this.pessoaOperadoraAIncluirDefault }
  }

  private classificacaoOperadoraAIncluirDefault: ClassificacaoOperadora = {
    id: null,
    classificacaoCodigoHis: null,
    classificacaoNome: null,
  }

  public classificacaoOperadoraAIncluir: ClassificacaoOperadora = { ...this.classificacaoOperadoraAIncluirDefault }

  @Mutation
  setClassificacaoOperadoraAIncluir(val: ClassificacaoOperadora) {
    this.classificacaoOperadoraAIncluir = val
  }

  @Mutation
  clearClassificacaoOperadoraAIncluir() {
    this.classificacaoOperadoraAIncluir = { ...this.classificacaoOperadoraAIncluirDefault }
  }

  @Action
  async addRegraCalculoOperadora() {
    try {
      const params: any = this.porOperadoraOuPorClassificacao === 'PorOperadora'
        ? { operadoraId: this.pessoaOperadoraAIncluir.userId, regraCalculoId: this.regraDeCalculo.id, hisId: this.pessoaOperadoraAIncluir.codigoHis }
        : { operadoraClassificacaoHospitalId: this.classificacaoOperadoraAIncluir.id, classificacaoCodigoHis: this.classificacaoOperadoraAIncluir.classificacaoCodigoHis, regraCalculoId: this.regraDeCalculo.id }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addRegraCalculoOperadora(params)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoOperadoraAll', {
          pagina: this.paginacaoOperadoras.page,
          qtdPorPagina: this.paginacaoOperadoras.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      // if (request.data === undefined) return { success: false, message: 'Ocorreu um erro na requisição.' }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeRegraCalculoOperadora(regraCalculoOperadoraId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeRegraCalculoOperadora(regraCalculoOperadoraId)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoOperadoraAll', {
          pagina: this.paginacaoOperadoras.page,
          qtdPorPagina: this.paginacaoOperadoras.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Procedimentos descartar */
  public regraDeCalculoProcedimentosDescartar: ProcedimentoDescartar[] = []

  @Mutation
  setRegraDeCalculoProcedimentosDescartar(regraDeCalculoProcedimentosDescartar: ProcedimentoDescartar[]) {
    this.regraDeCalculoProcedimentosDescartar = regraDeCalculoProcedimentosDescartar
  }

  @Mutation
  clearRegraDeCalculoProcedimentosDescartar() {
    this.regraDeCalculoProcedimentosDescartar = []
  }

  private paginacaoProcedimentosDescartarDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  public paginacaoProcedimentosDescartar: DataTablePagination = { ...this.paginacaoProcedimentosDescartarDefault }
  get procedimentosDescartarPaginationDefault() {
    return this.paginacaoProcedimentosDescartarDefault
  }

  @Mutation
  setPaginacaoProcedimentosDescartar(val: DataTablePagination) {
    this.paginacaoProcedimentosDescartar = val
  }

  @Action
  async getRegraCalculoProcedimentoDescartarAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoProcedimentosDescartar.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoProcedimentosDescartar.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegraCalculoProcedimentoDescartarAll(params)
      if (request.success) {
        this.context.commit('setRegraDeCalculoProcedimentosDescartar', request.data.itens as ProcedimentoDescartar[] || [])
        this.context.commit('setPaginacaoProcedimentosDescartar', {
          descending: false,
          page: pagination.page || this.paginacaoProcedimentosDescartar.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoProcedimentosDescartar.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoProcedimentosDescartar.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearRegraDeCalculoProcedimentosDescartar')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeRegraCalculoProcedimentoDescartar(procedimentoDescartarId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeRegraCalculoProcedimentoDescartar({
        regraCalculoId: this.regraDeCalculo.id,
        procedimentoDescartarId,
      })

      if (request.success) {
        await this.context.dispatch('getRegraCalculoProcedimentoDescartarAll', {
          pagina: this.paginacaoProcedimentosDescartar.page,
          qtdPorPagina: this.paginacaoProcedimentosDescartar.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  procedimentoDescartarDefault: ProcedimentoDescartar = {
    codigoProcedimento: '',
    descricaoProcedimento: '',
  }

  procedimentoDescartar: ProcedimentoDescartar = { ...this.procedimentoDescartarDefault }

  @Mutation
  setProcedimentoDescartar(val: ProcedimentoDescartar) {
    this.procedimentoDescartar = val
  }

  @Mutation
  clearProcedimentoDescartar() {
    this.procedimentoDescartar = { ...this.procedimentoDescartarDefault }
  }

  @Action
  async postRegraCalculoProcedimentoDescartar() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        ...this.procedimentoDescartar,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postRegraCalculoProcedimentoDescartar(params)
      if (request.success) {
        await this.context.dispatch('getRegraCalculoProcedimentoDescartarAll', {
          pagina: this.paginacaoProcedimentosDescartar.page,
          qtdPorPagina: this.paginacaoProcedimentosDescartar.rowsPerPage,
          regraCalculoId: this.regraDeCalculo.id,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Procedimentos */
  private paginacaoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  private procedimentosDefault: any = []
  public procedimentos: any = [...this.procedimentosDefault]
  public filtroPorProcedimentoList: any[] = []
  public procedimentoCompartilhado: any = []
  public procedimentoCompartilhadoId: string = ''
  public funcoesProcedimento: any = []
  public fontesPagadoras: any = []
  public hospitalGarantiaMinimaGlobal: string = ''
  public gruposRepasse: any = []
  public subGruposRepasse: any = []
  public gestores: any = []
  public locaisExecucao: any = []
  public prestadoresRepasse: any = []
  public transacaoFinanceiraList: any = []
  public profissionaisExecutantes: any = []
  public centroDeCusto: any = []
  public centroDeCustoId: string = ''
  public transacaoFinanceira: any = []
  public fontePagadoraField: any = null
  public tipoField: any = null
  public valorReferencia: any = 'ValorCalculado'
  public valoresReferencia: any = null
  public funcaoProcOrigem: string = ''
  public funcaoProcDestino: string = ''
  public planos: any = []
  public planosAbrangencia: any = []
  public idForDeleteHospital: any = ''
  public hospitaisGarantiaMinimaGlobal: any = []
  public valorReferenciaTipos: KeyDisplay[] = []
  public tipos: KeyDisplay[] = []
  public valorGarantiaMinima: number = 0
  public percentualAplicar: number = 0
  public codigoProcedimento: string = ''
  public selectedAbrangencia: string = ''
  public fatorPlano: string = ''
  public descricaoProcedimento: string = ''
  public codigoFiltroProcedimento: string = ''
  public descricaoFiltroProcedimento: string = ''

  public paginacaoProcedimentos: DataTablePagination = { ...this.paginacaoDefault }
  public paginacaoPlanos: DataTablePagination = { ...this.paginacaoDefault }

  @Mutation
  setPaginacaoProcedimentos(val: DataTablePagination) {
    this.paginacaoProcedimentos = val
  }

  @Mutation
  setSelectedAbrangencia(value: any) {
    this.selectedAbrangencia = value
  }

  @Mutation
  setFatorPlano(value: any) {
    this.fatorPlano = value
  }

  @Mutation
  setPaginacaoPlanos(val: DataTablePagination) {
    this.paginacaoPlanos = val
  }

  @Mutation
  setPlanosAbrangencia(value: any[]) {
    this.planosAbrangencia = value
  }

  @Mutation
  setHospitaisGarantiaMinimaGlobal(value: any[]) {
    this.hospitaisGarantiaMinimaGlobal = value
  }

  @Mutation
  setIdForDeleteHospital(value: any) {
    this.idForDeleteHospital = value
  }

  @Mutation
  setValorReferenciaTipos(value: KeyDisplay[]) {
    this.valorReferenciaTipos = value
  }

  @Mutation
  setTipos(value: KeyDisplay[]) {
    this.tipos = value
  }

  @Mutation
  setProcedimentos(procedimentos: Procedimentos[]) {
    this.procedimentos = procedimentos
  }

  @Mutation
  setFiltroPorProcedimentoList(procedimentos: any[]) {
    this.filtroPorProcedimentoList = procedimentos
  }

  @Mutation
  setCodigoFiltroProcedimento(value: string) {
    this.codigoFiltroProcedimento = value
  }

  @Mutation
  setDescricaoFiltroProcedimento(value: string) {
    this.descricaoFiltroProcedimento = value
  }

  @Mutation
  setProcedimentoCompartilhado(procedimento: any) {
    this.procedimentoCompartilhado = procedimento
  }

  @Mutation
  setPercentualAplicar(value: number) {
    this.percentualAplicar = value
  }

  @Mutation
  setPlanos(procedimentos: any) {
    this.planos = procedimentos
  }

  @Mutation
  setValorGarantiaMinima(value: number) {
    this.valorGarantiaMinima = value
  }

  @Mutation
  setCodigoProcedimento(value: string) {
    this.codigoProcedimento = value
  }

  @Mutation
  setDescricaoProcedimento(value: string) {
    this.descricaoProcedimento = value
  }

  @Mutation
  setFuncoesProcedimento(value: any[]) {
    this.funcoesProcedimento = value
  }

  @Mutation
  setFontesPagadoras(value: any[]) {
    this.fontesPagadoras = value
  }

  @Mutation
  setHospitalGarantiaMinimaGlobal(value: string) {
    this.hospitalGarantiaMinimaGlobal = value
  }

  @Mutation
  setGruposRepasse(value: any[]) {
    this.gruposRepasse = value
  }

  @Mutation
  setGestores(value: any[]) {
    this.gestores = value
  }

  @Mutation
  setLocaisExecucao(value: any[]) {
    this.locaisExecucao = value
  }

  @Mutation
  setSubGruposRepasse(value: any[]) {
    this.subGruposRepasse = value
  }

  @Mutation
  setFontePagadoraField(value: any) {
    this.fontePagadoraField = value
  }

  @Mutation
  setTipoField(value: any) {
    this.tipoField = value
  }

  @Mutation
  setValoresReferencia(value: any) {
    this.valoresReferencia = value
  }

  @Mutation
  setValorReferencia(value: any) {
    this.valorReferencia = value
  }

  @Mutation
  setFuncaoProcOrigem(value: string) {
    this.funcaoProcOrigem = value
  }

  @Mutation
  setFuncaoProcDestino(value: string) {
    this.funcaoProcDestino = value
  }

  @Mutation
  clearProcedimentos() {
    this.procedimentos = [...this.procedimentosDefault]
  }

  @Mutation
  clearProcedimentoCompartilhado() {
    this.procedimentoCompartilhado = []
  }

  @Mutation
  setProcedimentoCompartilhadoId(value: string) {
    this.procedimentoCompartilhadoId = value
  }

  @Mutation
  setModalProcedimentoCompartilhadoMode(value: string) {
    this.modalProcedimentoCompartilhadoMode = value
  }

  @Mutation
  setPrestadoresRepasse(value: any[]) {
    this.prestadoresRepasse = value
  }

  @Mutation
  setTransacaoFinanceira(value: any[]) {
    this.transacaoFinanceiraList = value
  }

  @Mutation
  setProfissionaisExecutantes(value: any[]) {
    this.profissionaisExecutantes = value
  }

  @Mutation
  setCentroDeCusto(value: any[]) {
    this.centroDeCusto = value
  }

  @Mutation
  clearCentroDeCusto() {
    this.centroDeCusto = []
  }

  @Mutation
  setTransacaoFinanceiraFixo(value: any[]) {
    this.transacaoFinanceira = value
  }

  @Mutation
  clearPlanos() {
    this.planos = []
  }

  @Action
  async getProcedimentosAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        procedimentoId: this.regraDeCalculo.id || '',
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentosAll(params)
      if (request.success) {
        this.context.commit('setProcedimentos', request.data.itens as Procedimentos[] || [])
        this.context.commit('setPaginacaoOperadoras', {
          descending: false,
          page: pagination.page || this.paginacaoOperadoras.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoOperadoras.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearProcedimentos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProcedimentoCompartilhadoAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentoCompartilhadoAll(params)
      if (request.success) {
        this.context.commit('setProcedimentoCompartilhado', request.data.itens || [])
        this.context.commit('setPaginacaoOperadoras', {
          descending: false,
          page: pagination.page || this.paginacaoOperadoras.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoOperadoras.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearProcedimentoCompartilhado')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPlanoAll(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoPlanos.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoPlanos.rowsPerPage,
        regraCalculoId: this.regraDeCalculo.id || '',
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPlanoAll(params)
      if (request.success) {
        this.context.commit('setPlanos', request.data.itens)
        this.context.commit('setPaginacaoPlanos', {
          descending: false,
          page: pagination.page || this.paginacaoPlanos.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoPlanos.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalRegistros,
          rowsPerPageItems: this.paginacaoPlanos.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('clearPlanos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProcedimentos(search: string) {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentosRegra(search)
      return response
    } catch (error) {
      this.context.commit('clearProcedimentos')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPlanosAbrangencia() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPlanosAbrangencia()
      if (response.success) {
        this.context.commit('setPlanosAbrangencia', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getValorReferenciaTipos() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValorReferenciaTipos()
      if (response.success) {
        this.context.commit('setValorReferenciaTipos', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTipos() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipos()
      if (response.success) {
        this.context.commit('setTipos', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getValoresReferencia() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getValoresReferencia()
      if (response.success) {
        this.context.commit('setValoresReferencia', response.data as KeyDisplay[] || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFiltroPorProcedimentoList(pagination: DataTablePagination) {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        pagina: pagination.page || this.paginacaoRegrasDeCalculo.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoRegrasDeCalculo.rowsPerPage,
      }

      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFiltroPorProcedimentoList(params)
      if (response.success) {
        this.context.commit('setFiltroPorProcedimentoList', response.data.itens)
        this.context.commit('setPaginacaoFiltroPorProcedimento', {
          descending: false,
          page: pagination.page || this.paginacaoPlanos.page,
          rowsPerPage: pagination.rowsPerPage || this.paginacaoPlanos.rowsPerPage,
          sortBy: null,
          totalItems: response.data.totalRegistros,
          rowsPerPageItems: this.paginacaoPlanos.rowsPerPageItems,
        })
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async postFiltroPorProcedimento() {
    try {
      const { id } = this.regraDeCalculo
      const params: any = {
        codigo: this.codigoFiltroProcedimento,
        descricao: this.descricaoFiltroProcedimento,
      }

      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postFiltroPorProcedimento(params, id)
      if (response.success) {
        await this.context.dispatch('getFiltroPorProcedimentoList', this.paginacaoProcedimentos)
        this.context.commit('setCodigoFiltroProcedimento', '')
        this.context.commit('setDescricaoFiltroProcedimento', '')
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteFiltroPorProcedimento(id: string) {
    try {
      const params: any = {
        filtroProcedimentoId: id,
        regraCalculoId: this.regraDeCalculo.id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteFiltroPorProcedimento(params)
      if (response.success) {
        await this.context.dispatch('getFiltroPorProcedimentoList', this.paginacaoProcedimentos)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFuncoesProcedimento() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFuncoesProcedimento()
      if (response.success) {
        this.context.commit('setFuncoesProcedimento', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getFontesPagadoras() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontesPagadoras()
      if (response.success) {
        this.context.commit('setFontesPagadoras', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getHospitaisGarantiaMinimaGlobal(pagination: DataTablePagination) {
    try {
      const params: any = {
        pagina: pagination.page || this.paginacaoOperadoras.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginacaoOperadoras.rowsPerPage,
        id: this.regraGarantiaMinimaId,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitaisGarantiaMinimaGlobal(params)
      if (response.success) {
        this.context.commit('setHospitaisGarantiaMinimaGlobal', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getGruposRepasse() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoRepasseAll()
      if (response.success) {
        this.context.commit('setGruposRepasse', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getGestores() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionais()
      if (response.success) {
        this.context.commit('setGestores', response.data.pessoas)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getLocaisExecucao() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontesPagadoras()
      if (response.success) {
        this.context.commit('setLocaisExecucao', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTransacaoFinanceira() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTransacaoFinanceira()
      if (response.success) {
        this.context.commit('setTransacaoFinanceira', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSubGruposRepasse(id: string) {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getSubGrupoRepasse(id)
      if (response.success) {
        this.context.commit('setSubGruposRepasse', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPrestadoresRepasse() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPessoaPrestadorAll({})
      this.context.commit('setPrestadoresRepasse', request.success ? request.data.prestadores : [])
      return request
    } catch (error) {
      this.context.commit('setPrestadoresRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getProfissionais() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionais()
      this.context.commit('setProfissionaisExecutantes', request.success ? request.data.pessoas : [])
      return request
    } catch (error) {
      this.context.commit('setProfissionaisExecutantes', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getCentroDeCusto() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getCentroDeCusto()
      if (request.success) this.context.commit('setCentroDeCusto', request.data || [])
      return request
    } catch (error) {
      this.context.commit('clearCentroDeCusto')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getTransacaoFinanceiraFixo() {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTransacaoFinanceira()
      if (response.success) {
        this.context.commit('setTransacaoFinanceiraFixo', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async addProcedimentos() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        valorGarantiaMinima: this.valorGarantiaMinima,
        codigoProcedimento: this.codigoProcedimento,
        descricaoProcedimento: this.descricaoProcedimento,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addProcedimentos(params)
      if (request.success) {
        await this.context.dispatch('getProcedimentosAll', this.paginacaoProcedimentos)
        this.context.commit('setValorGarantiaMinima', 0)
        this.context.commit('setCodigoProcedimento', '')
        this.context.commit('setDescricaoProcedimento', '')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addProcedimentoCompartilhado() {
    try {
      let params: any = {}

      if (this.modalProcedimentoCompartilhadoMode === 'CREATE') {
        params = {
          fontePagadoraId: this.fontePagadoraField,
          tipo: this.tipoField,
          regraCalculoId: this.regraDeCalculo.id,
          valorAplicar: this.percentualAplicar.toString(),
          funcaoProcOrigem: this.funcaoProcOrigem,
          funcaoProcDestino: this.funcaoProcDestino,
          valorReferencia: this.valorReferencia,
        }
      } else {
        params = {
          id: this.procedimentoCompartilhadoId,
          fontePagadoraId: this.fontePagadoraField,
          tipo: this.tipoField,
          regraCalculoId: this.regraDeCalculo.id,
          valorAplicar: this.percentualAplicar.toString(),
          funcaoProcOrigem: this.funcaoProcOrigem,
          funcaoProcDestino: this.funcaoProcDestino,
          valorReferencia: this.valorReferencia,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addProcedimentoCompartilhado(params)

      if (request.success) {
        await this.context.dispatch('getProcedimentoCompartilhadoAll', this.paginacaoProcedimentos)
        this.context.commit('setPercentualAplicar', 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addValorFixo() {
    try {
      let params: any = {}

      if (this.modeModalRegraValoresFixos === 'CREATE') {
        params = {
          fontePagadoraId: this.regraValorFixoItem.fontePagadoraId,
          prestadorId: this.regraValorFixoItem.prestadorId,
          profissionalExecutanteId: this.regraValorFixoItem.profissionalExecutanteId,
          valor: this.regraValorFixoItem.valor,
          descricao: this.regraValorFixoItem.descricao,
          tipo: this.regraValorFixoItem.tipo,
          inicioVigencia: this.regraValorFixoItem.inicioVigencia,
          fimVigencia: this.regraValorFixoItem.fimVigencia,
          centroDeCustoId: this.regraValorFixoItem.centroDeCusto,
          grupoRepasseId: this.regraValorFixoItem.grupoRepasseId,
          subGrupoRepasseId: this.regraValorFixoItem.subGrupoRepasseId,
          aplicaAluguel: this.regraValorFixoItem.aplicaAluguel,
          transacaoFinanceiraId: this.regraValorFixoItem.transacaoFinanceiraId,
        }
      } else {
        params = {
          id: this.regraValorFixoItem.id,
          fontePagadoraId: this.regraValorFixoItem.fontePagadoraId,
          prestadorId: this.regraValorFixoItem.prestadorId,
          profissionalExecutanteId: this.regraValorFixoItem.profissionalExecutanteId,
          valor: this.regraValorFixoItem.valor,
          descricao: this.regraValorFixoItem.descricao,
          tipo: this.regraValorFixoItem.tipo,
          inicioVigencia: this.regraValorFixoItem.inicioVigencia,
          fimVigencia: this.regraValorFixoItem.fimVigencia,
          centroDeCustoId: this.regraValorFixoItem.centroDeCusto,
          grupoRepasseId: this.regraValorFixoItem.grupoRepasseId,
          subGrupoRepasseId: this.regraValorFixoItem.subGrupoRepasseId,
          aplicaAluguel: this.regraValorFixoItem.aplicaAluguel,
          transacaoFinanceiraId: this.regraValorFixoItem.transacaoFinanceiraId,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addValorFixo(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addRegraGestao() {
    try {
      let params: any = {}

      if (this.modeModalRegraGestao === 'CREATE') {
        params = {
          fontePagadoraId: this.regraGestaoItem.fontePagadoraId,
          prestadorGestorId: this.regraGestaoItem.prestadorGestorId,
          gestorId: this.regraGestaoItem.gestorId,
          grupoRepasseId: this.regraGestaoItem.grupoRepasseId,
          localExecucaoId: this.regraGestaoItem.localExecucaoId,
          tipoCalculo: this.regraGestaoItem.tipoCalculo.key,
          valor: this.regraGestaoItem.valor,
          vigenciaInicio: this.regraGestaoItem.vigenciaInicio,
          vigenciaFim: this.regraGestaoItem.vigenciaFim,
        }
      } else {
        params = {
          id: this.regraGestaoItem.id,
          fontePagadoraId: this.regraGestaoItem.fontePagadoraId,
          prestadorGestorId: this.regraGestaoItem.prestadorGestorId,
          gestorId: this.regraGestaoItem.gestorId,
          grupoRepasseId: this.regraGestaoItem.grupoRepasseId,
          localExecucaoId: this.regraGestaoItem.localExecucaoId,
          tipoCalculo: this.regraGestaoItem.tipoCalculo.key,
          valor: this.regraGestaoItem.valor,
          vigenciaInicio: this.regraGestaoItem.vigenciaInicio,
          vigenciaFim: this.regraGestaoItem.vigenciaFim,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addRegraGestao(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addGarantiaMinima() {
    try {
      let params: any = {}

      if (this.modeModalGarantiaMinima === 'CREATE') {
        params = {
          valorGarantiaMinima: this.regraGarantiaMinimaItem.valorGarantiaMinima,
          prestadorId: this.regraGarantiaMinimaItem.prestadorId,
          profissionalExecutanteIdDestino: this.regraGarantiaMinimaItem.profissionalExecutanteIdDestino,
          fontePagadoraIdDestino: this.regraGarantiaMinimaItem.fontePagadoraIdDestino,
          grupoRepasseIdDestino: this.regraGarantiaMinimaItem.grupoRepasseIdDestino,
          centroDeCustoId: this.regraGarantiaMinimaItem.centroDeCustoId,
          vigenciaInicio: this.regraGarantiaMinimaItem.vigenciaInicio,
          vigenciaFim: this.regraGarantiaMinimaItem.vigencaFim,
          descricaoRegra: this.regraGarantiaMinimaItem.descricaoRegra,
          transacaoFinanceiraId: this.regraGarantiaMinimaItem.transacaoFinanceiraId,
          descricaoItemRecebimentoDestino: this.regraGarantiaMinimaItem.descricaoItemRecebimentoDestino,
        }
      } else {
        params = {
          id: this.regraGarantiaMinimaId,
          valorGarantiaMinima: this.regraGarantiaMinimaItem.valorGarantiaMinima,
          prestadorId: this.regraGarantiaMinimaItem.prestadorId,
          profissionalExecutanteIdDestino: this.regraGarantiaMinimaItem.profissionalExecutanteIdDestino,
          fontePagadoraIdDestino: this.regraGarantiaMinimaItem.fontePagadoraIdDestino,
          grupoRepasseIdDestino: this.regraGarantiaMinimaItem.grupoRepasseIdDestino,
          centroDeCustoId: this.regraGarantiaMinimaItem.centroDeCustoId,
          vigenciaInicio: this.regraGarantiaMinimaItem.vigenciaInicio,
          inicioVigencia: this.regraGarantiaMinimaItem.inicioVigencia,
          vigenciaFim: this.regraGarantiaMinimaItem.vigencaFim,
          descricaoRegra: this.regraGarantiaMinimaItem.descricaoRegra,
          transacaoFinanceiraId: this.regraGarantiaMinimaItem.transacaoFinanceiraId,
          descricaoItemRecebimentoDestino: this.regraGarantiaMinimaItem.descricaoItemRecebimentoDestino,
        }
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addGarantiaMinima(params)
      if (request.success) {
        this.context.dispatch('getRegrasGarantiaMinima', this.paginacaoGarantiaMinima)
        this.context.commit('setRegraDeCalculoIdGarantiaMinima', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addPlano() {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        abrangencia: this.selectedAbrangencia,
        fatorPlano: this.fatorPlano,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addPlano(params)
      if (request.success) {
        await this.context.dispatch('getPlanoAll', this.paginacaoPlanos)
        this.context.commit('setSelectedAbrangencia', '')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeProcedimento(procedimentoId: string) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeProcedimentoRegra(procedimentoId)
      if (request.success) await this.context.dispatch('getProcedimentosAll', this.paginacaoProcedimentos)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removeProcedimentoCompartilhado() {
    const params: any = {
      id: this.regraDeCalculo.id,
      regraCalculoId: this.procedimentoCompartilhadoId,
    }
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removeProcedimentoCompartilhado(params)
      if (request.success) await this.context.dispatch('getProcedimentoCompartilhadoAll', this.paginacaoProcedimentos)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async removePlano(regraCalculoPlanoId: string) {
    try {
      const params: any = {
        regraCalculoId: this.regraDeCalculo.id,
        regraCalculoPlanoId,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.removePlanoRegra(params)
      if (request.success) await this.context.dispatch('getPlanoAll', this.paginacaoPlanos)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addHospitalGarantiaMinimaGlobal() {
    try {
      const params: any = {
        regraCalculoGarantiaMinimaGlobalId: this.regraGarantiaMinimaId,
        hospitalId: this.hospitalGarantiaMinimaGlobal,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addHospitalGarantiaMinimaGlobal(params)
      if (request.success) {
        await this.context.dispatch('getHospitaisGarantiaMinimaGlobal', this.regraGarantiaMinimaId)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteHospitalGarantiaMinimaGlobal() {
    try {
      const params: any = {
        id: this.idForDeleteHospital,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteHospitalGarantiaMinimaGlobal(params)
      if (request.success) {
        await this.context.dispatch('getHospitaisGarantiaMinimaGlobal', this.regraGarantiaMinimaId)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
